var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"livePage"}},[(_vm.meettingLink)?_c('div',{staticClass:"info"},[_c('i',{staticClass:"el-icon-orange"}),_c('p',[_vm._v("请回到直播页面进行会诊。")]),_c('p',[_vm._v(" 如无法直接跳转直播页面请 "),_c('el-link',{attrs:{"type":"primary"},on:{"click":function($event){return _vm.toLivePage()}}},[_vm._v("点击跳转直播页面")])],1)]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }